import React from "react";
import { optionLabel, optionGroupDisabled, optionDependencyUnmet, optionInstanceLimitReached, effectiveQuantity } from "../lib/army";

export default function CheckboxGroup({ heading, list, entry, groupKey, onToggle, unit, siblings }) {
  if (!list || !list.length) return null;
  const effQty = effectiveQuantity(unit, entry);
  return (
    <div className="upgrade-list">
      {heading ? <div className="upgrade-list-heading">{heading}</div> : null}
      {list.map((item) => {
        const checked = entry[groupKey].includes(item.id);
        const disabled = optionGroupDisabled(unit, entry, item.id) || optionDependencyUnmet(item, entry) || optionInstanceLimitReached(item, entry, siblings);
        const label = groupKey === "upgrades" ? `${item.name} (+${item.points})` : optionLabel(item, effQty);
        return (
          <label key={item.id} className={disabled ? "opt-disabled" : ""}>
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={() => onToggle(entry.instanceId, groupKey, item.id)}
              data-testid={`chk-${entry.instanceId}-${groupKey}-${item.id}`}
            />
            {label}
          </label>
        );
      })}
    </div>
  );
}
